import type {Wallet, WalletSession} from 'src/v2/state/types';
import type {SupportedNetwork} from '@stripe-internal/wallet-connect-wrapper';
import {WalletProvider} from 'src/types';

type UpdateParams = {
  walletAddress: string;
  network: SupportedNetwork;
  type: WalletProvider;
  walletKey?: string;
};

export const syncWalletToSession = async (
  activeWallet: Wallet,
  walletSessions: WalletSession[],
  updateSession: (params: UpdateParams) => Promise<void>,
): Promise<void> => {
  const {address, network, type, key} = activeWallet;

  const matchingSession = walletSessions.find(
    (session) =>
      session.address === address &&
      session.network === network &&
      session.connected,
  );

  if (!matchingSession) {
    await updateSession({
      walletAddress: address,
      network,
      type,
      walletKey: key,
    });
  }
};
